/* unplugin-vue-components disabled */import script from "./DramaDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DramaDetail.vue?vue&type=script&setup=true&lang=js"

import "./DramaDetail.vue?vue&type=style&index=0&id=53667c34&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53667c34"]])

export default __exports__